module.exports = __webpack_public_path__ + "media/V48.20e5f920.mp4";